import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { Card, PageHeader, Row, Col, Button } from 'antd'
import Filters, { FilterItem, Types } from '../../components/Filters'
import GroupList from '../../components/GroupList'
import { GroupForm } from '../../components/Forms'
import { SpecieProvider, SpecieConsumer } from '../../context/SpecieContext'
import { GroupProvider, GroupConsumer } from '../../context/GroupContext'

export default class Group extends Component {

  private groupFilterDispatchOptions = {
    search: {
      deleted: false,
      public_group_species: {
        with: {
          deleted: false,
          specie: {
            with: true
          }
        }
      }
    },
    options: {
      sort: ['name']
    }
  } as const

  groupListSearch = {
    search: {
      deleted: false,
      public_group_species: {
        with: {
          deleted: false,
          specie: {
            with: true
          }
        }
      }
    },
    options: {
      sort: ['name']
    }
  }

  handleFiltersSubmit = (payload: any) => {
    if (payload && payload.search) {
      this.groupListSearch.search = payload.search
    }
  }

  renderAdd = () => {
    const { permissions }: any = this.props
    if (!permissions.create) return null

    return (
      <Link to="group/add">
        <Button type="primary" shape="round">
          Create new group
        </Button>
      </Link>
    )
  }

  render() {
    const { permissions, history, goBack, match: { params: { groupUuid } } }: any = this.props

    return (
      <GroupProvider>
        <SpecieProvider>
          <SpecieConsumer>
            {({ fetching: fetchingSpecies, species, requestSpecieList }) => (
              <GroupConsumer>
                {({ fetching, error, groups, group, pagination, requestGroupList, requestGroupFind, requestGroupCreate, requestGroupUpdate, requestGroupDelete }) => {
    
                  // Edit user
                  if (groupUuid) {
                    let addon: any = {
                      data: group,
                      permissions: permissions,
                      species: species
                    }
                    if (groupUuid !== 'add') {
                      addon = {
                        ...addon,
                        uuid: groupUuid
                      }
                    }
    
                    return (
                      <Card>
                        <PageHeader title={groupUuid === 'add' ? 'New Group' : 'Edit Group'} onBack={() => goBack('/admin/group')}>
                          <GroupForm
                            {...addon}
    
                            loading={fetching}
                            contentLoading={fetchingSpecies}
                            
                            error={error}
                            history={history}
    
                            loadGroup={requestGroupFind}
                            loadSpecies={requestSpecieList}

                            dispatchCreate={requestGroupCreate}
                            dispatchUpdate={requestGroupUpdate}
                          />
                        </PageHeader>
                      </Card>
                    )
                  }
    
                  return (
                    <>
                      <Card title="Filters" style={{marginBottom: 25}}>
                        <Filters size="medium" loading={fetching} history={history} defaultSubmitOptions={this.groupFilterDispatchOptions} submitDispatch={requestGroupList} onSubmit={this.handleFiltersSubmit}>
                          {({ values, handleFilterChange }: any) => (
                            <Row gutter={9} style={{width: '100%'}}>
                              <Col xs={24} md={12}>
                                <FilterItem
                                  name="uuid"
                                  type={Types.INPUT}
                                  placeholder="Filter by UUID"
                                  value={values['uuid']}
                                  size="medium"
                                  options={{
                                    input: {
                                      allowClear: true
                                    }
                                  }}
                                  onChange={handleFilterChange}
                                />
                              </Col>
    
                              <Col xs={24} md={12}>
                                <FilterItem
                                  name="name.ilike"
                                  type={Types.INPUT}
                                  placeholder="Filter by Name"
                                  value={values['name.ilike']}
                                  size="medium"
                                  options={{
                                    input: {
                                      allowClear: true
                                    }
                                  }}
                                  onChange={handleFilterChange}
                                />
                              </Col>
                            </Row>
                          )}
                        </Filters>
                      </Card>
    
                      <Card title="List of Groups" extra={this.renderAdd()}>
                        <GroupList
                          loading={fetching}
                          groups={groups}
                          pagination={pagination}
                          permissions={permissions}
                          history={history}
                          searchOptions={this.groupListSearch}
                          loadGroups={requestGroupList}
                          deleteGroup={requestGroupDelete}
                        />
                      </Card>
                    </>
                  )
                }}
              </GroupConsumer>
            )}
          </SpecieConsumer>
        </SpecieProvider>
      </GroupProvider>
    )
  }
}
